import {getLoginInformation} from './loginHelper';
import {sendPaymentInfoToBackend} from './backendUtils';

const initializeRazorpay = (
    val, orderId, paymentConfig,
    errorCB, successCB) => {
        let contact  = ''
        if(paymentConfig.userConfig &&
           paymentConfig.userConfig.config &&
           paymentConfig.userConfig.config.razorpayConfig
        ){
            contact= paymentConfig.userConfig.config.razorpayConfig.contact;
        }
        let loginInformation = getLoginInformation();
    console.log('orderId', orderId )
    var options = {
        "key": "rzp_live_2AuB8cFFgm3Qs8", // Enter the Key ID generated from the Dashboard
        "amount": val*100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        "currency": "INR",
        "name": "Glip",
        "description": "Buy Stream Power",
        "image": "https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/assets/rzplogo.png",
        "order_id": orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        "handler": async function (response){
            //alert(response.razorpay_payment_id);
            //alert(response.razorpay_order_id);
            //alert(response.razorpay_signature);
            console.log('response', response);
            await sendPaymentInfoToBackend(
                orderId, response.razorpay_payment_id);
            successCB();
        },
        "prefill": {
            "name": loginInformation.user.username,
            "email": loginInformation.user.email,
            'contact': contact
        },
        "notes": {
            "address": "Gliphouse"
        },
        "theme": {
            "color": "#76ee00"
        }
    };
    var rzp1 = new Razorpay(options);
    rzp1.on('payment.failed', function (response){
        /* alert(response.error.code);
         * alert(response.error.description);
         * alert(response.error.source);
         * alert(response.error.step);
         * alert(response.error.reason);
         * alert(response.error.metadata.order_id);
         * alert(response.error.metadata.payment_id); */
        errorCB(response.error.description);
        //setError(response.error.description);
        //setTimeout(()=>{setError('')}, 5000);
    });
    rzp1.open();
}
export {initializeRazorpay};
